import React from 'react';
import { useSelector } from 'react-redux';

const RTLTranslate = ({ text }) => {
  const allConfigs = useSelector((state) => state.globalState.allConfigs);

  return allConfigs.Translation && allConfigs.Translation[text]
    ? allConfigs.Translation[text]
    : text;
};

export default RTLTranslate;
